import ConfirmationModal from "../../common_nextgen/common_components/Modal/ConfirmationModal";
import NextGenPaginator from "../../common_nextgen/common_components/Pagination/NextGenPaginator";
import ButtonsSection from "../../common_nextgen/common_components/SearchScreenComponents/ButtonsSection";
import DisplayTable from "../../common_nextgen/common_components/SearchScreenComponents/DisplayTable";
import SearchBox from "../../common_nextgen/common_components/SearchScreenComponents/SearchBox";
import useLicsSchedule from "./hooks/useLicsSchedule";

const LicsSchedule = () => {
    const licsScheduleData = useLicsSchedule();

    return (
        <div class="container container-fluid">
            <ButtonsSection ctaButtons={licsScheduleData.leftButtons}align="left" />
            <div className="header-section">
                <h1>
                    {licsScheduleData.screen_title} -{" "}
                    <span className="heading-cod">{licsScheduleData.screenNumber}</span>
                </h1>
            </div>
            <SearchBox
                formFields={licsScheduleData.formFields}
                dropdownValues={licsScheduleData.dropdownValues}
                paramsData={licsScheduleData.paramsData}
                updataParamData={licsScheduleData.updateParamData}
            />
            <ButtonsSection ctaButtons={licsScheduleData.ctaButtons} />
            <DisplayTable
                data={licsScheduleData.data}
                parmKey={licsScheduleData.parmKey}
                menuOptions={licsScheduleData.menuOptions}
                tableHeaders={licsScheduleData.columnDef}
                setRowData={licsScheduleData.setRowData}
                selectedPriceSchedules={licsScheduleData.selectedRows}
                setSelectedPriceSchedules={licsScheduleData.setSelectedRows}
            />
            <div className="paginator-container">
                <NextGenPaginator
                    first={licsScheduleData.first}
                    rows={licsScheduleData.rows}
                    totalRecords={licsScheduleData.totalRecords}
                    currentPage={licsScheduleData.currentPage}
                    rowsPerPageOptions={[10, 25, 50]}
                    onPageChange={licsScheduleData.onPageChange}
                />
            </div>
            {licsScheduleData.isConfirmationModalOpen && (
                <ConfirmationModal
                    isOpen={licsScheduleData.isConfirmationModalOpen}
                    onRequestClose={licsScheduleData.closeConfirmationModal}
                    onBack={licsScheduleData.closeConfirmationModal}
                    onSave={licsScheduleData.deleteLicsSchedule}
                    confirmLabel="Confirm(Y/N)"
                    options={[
                        { label: "N-No", value: "no" },
                        { label: "Y-Yes", value: "yes" },
                    ]}
                    setSelectedOption={licsScheduleData.setSelectedOption}
                />
            )}
        </div>
    );
};

export default LicsSchedule;